/**
 * Renovar: abre a página de compra em outra aba. Na Máquina de Leads, o link leva o email da
 * conta (desconto e atribuição), como o selo da Home e a barra do rodapé.
 */
import { externalUrls } from '../../config/env';
import { emitActivity } from '../../lib/activity';
import { genPromo } from '../../lib/promo';

export function openRenewal(source: string, email: string, where: 'account' | 'menu' | 'guide'): void {
  emitActivity('renew.clicked', { where });
  let url: string =
    source === 'lead-machine' ? externalUrls.buyLeadMachine : externalUrls.buyEminer;
  if (source === 'lead-machine' && email) url += '/' + genPromo({ email });
  window.open(url, '_blank');
}
